import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import { ReactComponent as DriverIcon } from 'icons/driving-wheel-icon.svg';
import { ReactComponent as LuggageIcon } from 'icons/luggage-icon.svg';
import { ReactComponent as AdultsIcon } from 'icons/adults-icon.svg';
import { Button, InputField, SelectField, TableWrapper, UploadVehicleImage } from 'components/Global';
import SelectFieldDate from 'components/Global/SelectFieldDate';
import SelectFieldImage from 'components/Global/SelectFieldImage';
import { format, parseISO } from 'date-fns';
import { uploadFile } from 'features/orders/actions';
import { useAppContext } from 'components/Context/AppContext';
import { useDispatch, useSelector } from 'react-redux';
import {
  createNewDriver,
  editDriver,
  getDetailDriver,
  getDriverRating,
  getDriverReviews,
  getDriverTransactionHistory,
  processDriverVerification,
  switchDriverStatus,
  uploadImageVehicle,
} from 'features/drivers/actions';
import { checkEmptyObject, checkPermission } from 'utils/functionality';
import { trackEvent } from 'utils/analytics';
import SelectFieldBanks from 'components/Global/SelectFieldBanks';
import { getAllBanks, getAllCurrencies } from 'features/banks/actions';
import SelectFieldShuttle from 'components/Global/SelectFieldShuttle';
import { getAllRentalLocation } from 'features/rental-location/actions';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import { useLocation } from 'react-router-dom';
import { getAllCategories } from 'features/category/actions';
import { deleteImageVehicle } from 'features/drivers/slice';
import Tabs, { TabPane } from 'components/Global/Tabs';
import DriverBalance from '../DriverBalance';
import DriverReview from '../DriverReview';
import InputRatingStars from 'components/Global/InputRatingStars';

const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const getPathname = (url) => {
  try {
    const urlObj = new URL(url);
    const result = urlObj.pathname + urlObj.search;
    return result;
  } catch {
    return url;
  }
};

const UserStatus = ({ isUserBlocked, blockUserHandler }) => {
  return (
    <div className="status-info">
      <h3>{isUserBlocked ? 'Non Aktif' : 'Aktif'}</h3>
      <div className="status-info__toggle-wrapper">
        <div className="user__toggle-status">
          <label className="switch">
            <input type="checkbox" onChange={blockUserHandler} role={'switch'} checked={!isUserBlocked} />
            <span className="slider"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

const AddNewDriver = () => {
  const { driverId } = useParams();
  const { showToast, setShowRejectDriverModal } = useAppContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedDate, setSelectedDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isUserBlocked, setIsUserBlocked] = useState(false);
  const [mappedCurrencies, setMappedCurrencies] = useState([]);
  const [data, setData] = useState({
    fullname: '',
    email: '',
    phone: '',
    date_of_birth: '',
    photo_ktp: '',
    photo_license: '',
    selfie: '',
    letter_of_agreement: '',
    bank_name: '',
    bank_account_number: '',
    currency: '',
    location_name: '',
    location_id: '',
    domicile: '',
    vehicle_name: '',
    vehicle_number_plate: '',
    vehicle_category_id: '',
    vehicle_max_passanger: 0,
    vehicle_max_suitcases: 0,
    vehicle_photo: [],
  });
  const [activeTab, setActiveTab] = useState('Saldo Driver');
  const { offCanvasMenu, currentMenu } = useSelector((state) => state.menu);
  const { data: dataBanks } = useSelector((state) => state.banks);
  const { data: rentalLocationData } = useSelector((state) => state.rentalLocation);
  const { data: dataCurrencies } = useSelector((state) => state.currency);
  const { data: dataCategory } = useSelector((state) => state.category);
  const { selected: driverData, rating: driverRating } = useSelector((state) => state.drivers);
  const [searchParams] = useSearchParams();
  const isEdit = searchParams.get('is_edit');
  const isVerificationPage = location.pathname.includes('verification');

  const user = useSelector((state) => state.user.profile);

  const backHandler = () => {
    navigate(-1);
  };

  const isDriverVerificationEnabled = useFliptBoolean(
    'FLAG_FE_DRIVER_ADMIN_VERIFICATION',
    false,
    user.id || 'anonymous',
  );
  const isEnhancementReviewDriver = useFliptBoolean('FLAG_FE_ENHANCEMENT_REVIEW_DRIVER', false, user.id || 'anonymous');
  const isNewUploadDocumentEnabled = useFliptBoolean('FLAG_FE_NEW_UPLOAD_DOCUMENT', false, user.id || 'anonymous');

  const handleSubmit = async () => {
    if (data.fullname.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Mengisi Nama' });
    } else if (data.email.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Mengisi Email' });
    } else if (!new RegExp(regexEmail).test(data.email)) {
      return showToast({ type: 'error', message: 'Format Email Tidak Valid' });
    } else if (data.phone.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Mengisi No. Handphone' });
    } else if (data.date_of_birth.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Mengisi Tanggal Lahir' });
    } else if (data.domicile.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Mengisi Domisili Driver' });
    } else if (data.location_name.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Memilih Lokasi Driver' });
    } else if (data.currency.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Memilih Currency' });
    } else if (data.bank_account_number.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Mengisi Nomor Rekening' });
    } else if (data.bank_name.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Memilih Bank' });
    } else if (data.vehicle_name.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Mengisi Nama Mobil' });
    } else if (data.vehicle_number_plate.trim() === '') {
      return showToast({ type: 'error', message: 'Harap Mengisi Nomor Polisi' });
    }

    if (isNewUploadDocumentEnabled) {
      if (!data.photo_ktp || checkEmptyObject(data.photo_ktp)) {
        return showToast({ type: 'error', message: 'Harap Memilih File KTP' });
      } else if (!data.photo_license || checkEmptyObject(data.photo_license)) {
        return showToast({ type: 'error', message: 'Harap Memilih File SIM' });
      } else if (!data.selfie || checkEmptyObject(data.selfie)) {
        return showToast({ type: 'error', message: 'Harap Memilih File Selfie' });
      }
    } else {
      if (data.photo_ktp.trim() === '') {
        return showToast({ type: 'error', message: 'Harap Memilih File KTP' });
      } else if (data.photo_license.trim() === '') {
        return showToast({ type: 'error', message: 'Harap Memilih File SIM' });
      } else if (data.selfie.trim() === '') {
        return showToast({ type: 'error', message: 'Harap Memilih File Selfie' });
      }
    }

    if (data.currency && !mappedCurrencies?.find((item) => item.name === data.currency)) {
      return showToast({ type: 'error', message: 'Harap Memilih Currency Yang Tersedia' });
    } else if (data.bank_name && !dataBanks?.data?.find((item) => item.name === data.bank_name)) {
      return showToast({ type: 'error', message: 'Harap Memilih Bank Yang Tersedia' });
    }

    if (data.vehicle_category_id) {
      if (!data.vehicle_max_suitcases) {
        return showToast({ type: 'error', message: 'Masukan Kapasitas Koper' });
      } else if (!data.vehicle_max_passanger) {
        return showToast({ type: 'error', message: 'Masukan Kapasitas Penumpang' });
      } else if (!data.vehicle_photo || data.vehicle_photo.length === 0) {
        return showToast({ type: 'error', message: 'Masukan Foto Mobil' });
      }
    }

    let photo_ktp = data.photo_ktp;
    let photo_license = data.photo_license;
    let selfie = data.selfie;
    let letter_of_agreement = data.letter_of_agreement;

    if (isNewUploadDocumentEnabled) {
      photo_ktp = data.photo_ktp?.key;
      photo_license = data.photo_license?.key;
      selfie = data.selfie?.key;
      letter_of_agreement = data.letter_of_agreement?.key;
    }

    try {
      if (isEdit) {
        await dispatch(
          editDriver({
            payload: {
              ...data,
              vehicle_photo: data.vehicle_photo?.map((item) => (item.name ? item.name : item)),
              photo_ktp,
              photo_license,
              selfie,
              letter_of_agreement,
            },
            id: driverId,
          }),
        ).unwrap();
        showToast({ type: 'success', message: 'Berhasil Merubah Data Akun Driver' });
      } else {
        await dispatch(
          createNewDriver({
            ...data,
            registration_type: 'email',
            photo_ktp,
            photo_license,
            selfie,
            letter_of_agreement,
          }),
        ).unwrap();
        showToast({ type: 'success', message: 'Berhasil Membuat Akun Driver' });
      }
      navigate(-1);
    } catch (error) {
      if (isEdit) {
        showToast({ type: 'error', message: 'Gagal Merubah Data Akun Driver' + `[${error?.message}]` });
        return;
      }
      showToast({ type: 'error', message: 'Gagal Membuat Akun Driver' + `[${error?.message}]` });
    }
  };

  const onChangeImage = async (e, imageVar) => {
    if (!e.target.files.length) return;

    const file = e.target.files[0];
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes

    if (file.size > maxSize) {
      showToast({ type: 'error', message: 'File size must be less than 2MB' });
      return;
    }

    let documentTypeName = undefined;

    if (isNewUploadDocumentEnabled) {
      switch (imageVar) {
        case 'photo_ktp':
          documentTypeName = 'ktp';
          break;
        case 'photo_license':
          documentTypeName = 'sim';
          break;
        default:
          documentTypeName = imageVar;
      }
    }

    try {
      const uploadImage = await dispatch(uploadFile({ file, name: imageVar, documentType: documentTypeName })).unwrap();
      if (isNewUploadDocumentEnabled) {
        setData((prev) => ({
          ...prev,
          [imageVar]: {
            file,
            name: file.name,
            key: uploadImage[imageVar]?.key,
          },
        }));
      } else {
        setData((prev) => ({ ...prev, [imageVar]: uploadImage[imageVar] }));
      }
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal Melakukan Upload File' });
    }
  };

  const onRemoveImage = (imageVar) => {
    setData((prev) => ({ ...prev, [imageVar]: '' }));
  };

  const blockUserHandler = async () => {
    if (isDriverVerificationEnabled && isVerificationPage) return;
    try {
      trackEvent('driver_status_changed', {
        driver_id: driverId,
        source: 'add_driver',
      });
      await dispatch(switchDriverStatus(driverId)).unwrap();
      showToast({ type: 'success', message: 'Berhasil Melakukan Aksi' });
      dispatch(getDetailDriver(driverId));
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal Melakukan Aksi: ' + error.message });
    }
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current
    // function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const handleRemoveImageVehicle = (image) => {
    const updatedPhotos = driverData?.vehicle.photo?.filter((item) => {
      if (typeof item === 'string') {
        return item !== image;
      } else {
        return item.name !== image;
      }
    });

    dispatch(deleteImageVehicle(updatedPhotos));
  };

  const handleUploadImageVehicle = (image) => {
    dispatch(uploadImageVehicle(image));
  };

  const rejectDriverHandler = () => {
    dispatch(getDetailDriver(driverId));
    setShowRejectDriverModal(true);
  };

  const approveDriverHandler = async () => {
    const payload = {
      id: driverId,
      data: { status: 'approved' },
    };

    try {
      await dispatch(processDriverVerification(payload)).unwrap();
      showToast({ type: 'success', message: 'Verifikasi driver berhasil diterima' });
      navigate('/driver?tab-active=Verifikasi+Driver+Baru', { replace: true });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      showToast({ type: 'error', message: 'Gagal proses verifikasi terima driver' });
    }
  };

  const driverButtonView = () => {
    if (!driverId || isEdit) {
      return (
        <div className="driver__buttons">
          <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
            Kembali
          </Button>

          {(!driverId || (isEdit && checkPermission(offCanvasMenu, currentMenu, 'update'))) && (
            <Button
              size="sm"
              className="button"
              variant={isEdit ? 'success' : 'primary'}
              width={208}
              onClick={handleSubmit}
            >
              Simpan
            </Button>
          )}
        </div>
      );
    } else if (isDriverVerificationEnabled && isVerificationPage && driverData?.status === 'new') {
      return (
        <div className="driver__buttons">
          <Button variant="danger" className="button" width={208} size="sm" onClick={rejectDriverHandler}>
            Tidak Sesuai
          </Button>

          <Button size="sm" className="button" variant="success" width={208} onClick={approveDriverHandler}>
            Sesuai
          </Button>
        </div>
      );
    }
  };

  const handleChangeTab = (tab) => {
    setCurrentPage(1);
    setActiveTab(tab);
  };

  const renderDriverTabs = () => {
    if (isEnhancementReviewDriver && driverId) {
      if (isVerificationPage) return null;
      return (
        <div style={{ marginTop: 22 }}>
          <Tabs activeTab={activeTab} setActiveTab={handleChangeTab}>
            <TabPane label="Saldo Driver">
              <DriverBalance currentPage={currentPage} setCurrentPage={setCurrentPage} />
            </TabPane>
            <TabPane label="Review Driver">
              <DriverReview currentPage={currentPage} setCurrentPage={setCurrentPage} />
            </TabPane>
          </Tabs>
        </div>
      );
    }

    if (driverId) {
      return (
        <div style={{ marginTop: 22 }}>
          <DriverBalance currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      );
    }
  };

  useEffect(() => {
    if (!driverId) return;
    dispatch(getDetailDriver(driverId));
    dispatch(getDriverRating(driverId));
  }, [driverId, dispatch]);

  useEffect(() => {
    if (!driverId) return;
    dispatch(getDriverTransactionHistory({ id: driverId, limit: 10, page: currentPage }));
    dispatch(getDriverReviews({ id: driverId, page: currentPage }));
  }, [driverId, currentPage, dispatch]);

  useEffect(() => {
    dispatch(getAllBanks());
    dispatch(getAllRentalLocation());
    dispatch(getAllCurrencies());
    dispatch(getAllCategories({ page: 1 }));
  }, []);

  useEffect(() => {
    if (checkEmptyObject(dataCurrencies)) return;
    setMappedCurrencies(() =>
      dataCurrencies.data?.map((item) => ({
        ...item,
        name: item.symbol,
        value: item.symbol.toLowerCase(),
      })),
    );
  }, [dataCurrencies]);

  useEffect(() => {
    if (checkEmptyObject(driverData)) return;

    let photo_ktp = driverData.PersonalInfos?.ktp || '';
    let photo_license = driverData.PersonalInfos?.sim || '';
    let selfie = driverData.PersonalInfos?.selfie || '';
    let letter_of_agreement = driverData.PersonalInfos?.letter_of_agreement || '';

    if (isNewUploadDocumentEnabled) {
      photo_ktp = getPathname(driverData.PersonalInfos?.ktp);
      photo_license = getPathname(driverData.PersonalInfos?.sim);
      selfie = getPathname(driverData.PersonalInfos?.selfie);
      letter_of_agreement = getPathname(driverData.PersonalInfos?.letter_of_agreement);
    }

    setData({
      fullname: driverData.name || '',
      email: driverData.email || '',
      phone: driverData.phone || '',
      date_of_birth: driverData.PersonalInfos?.date_of_birth || '',
      photo_ktp,
      photo_license,
      selfie,
      letter_of_agreement,
      bank_account_number: driverData.account_bank?.no_rek || '',
      bank_name: driverData.account_bank?.nama_bank || '',
      currency: driverData.user_location?.currency || '',
      location_name: driverData.user_location?.location_name || '',
      location_id: driverData.user_location?.location_id || '',
      domicile: driverData?.PersonalInfos?.domicile || '',
      vehicle_name: driverData?.vehicle?.name || '',
      vehicle_number_plate: driverData?.vehicle?.license_number || '',
      vehicle_category_id: driverData?.vehicle?.category?.id || '',
      vehicle_max_suitcases: driverData?.vehicle?.max_suitcase || '',
      vehicle_max_passanger: driverData?.vehicle?.max_passanger || '',
      vehicle_photo: driverData?.vehicle?.photo || [],
    });
    setSelectedDate(() =>
      driverData.PersonalInfos?.date_of_birth ? parseISO(driverData.PersonalInfos?.date_of_birth) : '',
    );
    setIsUserBlocked(() => driverData.is_deactivated);
  }, [driverData]);

  useEffect(() => {
    if (isEdit || driverId) return;
    setData({ ...data, vehicle_photo: driverData?.vehicle?.photo });
  }, [driverData.vehicle?.photo]);

  return (
    <div className="driver">
      <header className="driver__header" onClick={backHandler}>
        <LeftArrow />
        <p>Kembali</p>
      </header>
      <TableWrapper
        icon={<DriverIcon fill="#009EF7" width="25px" height="25px" />}
        title="Driver"
        CustomFilterComponent={
          driverId && !isVerificationPage ? (
            <UserStatus isUserBlocked={isUserBlocked} blockUserHandler={blockUserHandler} />
          ) : null
        }
      >
        <div className="driver__wrapper">
          <h1 className="driver__title">{driverId ? (isEdit ? 'Edit Driver' : 'Detail Driver') : 'Tambah Driver'}</h1>
          <div className="driver__input-group">
            <InputField
              label="Nama"
              disable={driverId && !isEdit}
              value={data.fullname}
              onChange={(e) => setData((prev) => ({ ...prev, fullname: e.target.value }))}
              placeholder="Masukan Nama"
              className="input-field"
            />
            <InputField
              label="Email"
              disable={driverId}
              value={data.email}
              onChange={(e) => setData((prev) => ({ ...prev, email: e.target.value }))}
              placeholder="Masukan Email"
              className="input-field"
            />
            <InputField
              label="No. Handphone"
              disable={driverId && !isEdit}
              type="number"
              value={data.phone}
              onChange={(e) => setData((prev) => ({ ...prev, phone: e.target.value }))}
              placeholder="Masukan No. Handphone"
              className="input-field"
              onWheel={numberInputOnWheelPreventChange}
            />
            <SelectFieldDate
              label="Tanggal Lahir"
              disable={driverId && !isEdit}
              htmlFor="tanggal-lahir"
              name="tanggal-lahir"
              defaultMonth={selectedDate}
              handleDaySelect={(date) => {
                if (date) {
                  setSelectedDate(date);
                  setData((prev) => ({
                    ...prev,
                    date_of_birth: format(date, 'yyyy-MM-dd').toString(),
                  }));
                }
              }}
              value={selectedDate ? format(selectedDate, 'dd/MM/yyyy') : ''}
              selectedDay={selectedDate}
              placeholder="Pilih Tanggal"
              forDateOfBirth
            />
            <div
              className={
                isEnhancementReviewDriver && !isVerificationPage && driverId ? 'driver__input-group__rating' : ''
              }
            >
              <InputField
                label="Domisili Driver"
                disable={driverId && !isEdit}
                value={data.domicile}
                onChange={(e) => setData((prev) => ({ ...prev, domicile: e.target.value }))}
                placeholder="Tulis Domisili Driver"
                className="input-field"
              />
              {isEnhancementReviewDriver && !isVerificationPage && driverId && (
                <InputRatingStars value={driverRating?.total_reviews > 0 ? driverRating?.driver_rating : 0} size={18} />
              )}
            </div>
            <SelectFieldShuttle
              label="Lokasi"
              htmlFor="lokasi"
              value={data.location_id}
              data={rentalLocationData}
              onChange={(e) =>
                setData((prev) => ({ ...prev, location_id: e.id, location_name: e.name, currency: e.currency }))
              }
              disable={driverId && !isEdit}
              placeholder="Pilih Lokasi"
              searchFeature
            />
            <SelectFieldImage
              label="KTP"
              disabled={driverId && !isEdit}
              value={data.photo_ktp}
              onChange={(e) => onChangeImage(e, 'photo_ktp')}
              onRemove={() => onRemoveImage('photo_ktp')}
            />
            <SelectFieldImage
              label="SIM"
              disabled={driverId && !isEdit}
              value={data.photo_license}
              onChange={(e) => onChangeImage(e, 'photo_license')}
              onRemove={() => onRemoveImage('photo_license')}
            />
            <SelectFieldImage
              label="Foto Selfie"
              disabled={driverId && !isEdit}
              value={data.selfie}
              onChange={(e) => onChangeImage(e, 'selfie')}
              onRemove={() => onRemoveImage('selfie')}
            />
            <SelectFieldImage
              label="Surat Perjanjian"
              disabled={driverId}
              value={data.letter_of_agreement}
              onChange={(e) => onChangeImage(e, 'letter_of_agreement')}
              onRemove={() => onRemoveImage('letter_of_agreement')}
            />
            <InputField
              label="Nomor Rekening"
              disable={driverId && !isEdit}
              type="number"
              value={data.bank_account_number}
              onChange={(e) => setData((prev) => ({ ...prev, bank_account_number: e.target.value }))}
              placeholder="Masukan Nomor Rekening"
              className="input-field"
              onWheel={numberInputOnWheelPreventChange}
            />
            <SelectFieldBanks
              className="input-bank"
              htmlFor="metode-pembayaran-bank"
              label="Nama Bank"
              placeholder="Cari Bank..."
              data={dataBanks?.data || []}
              value={data.bank_name}
              disable={driverId && !isEdit}
              onChange={(e) => setData((prev) => ({ ...prev, bank_name: e.target.value }))}
              onClick={(e) => setData((prev) => ({ ...prev, bank_name: e }))}
            />
            <InputField
              label="Nama Mobil"
              disable={driverId && !isEdit}
              value={data.vehicle_name}
              onChange={(e) => setData((prev) => ({ ...prev, vehicle_name: e.target.value }))}
              placeholder="Masukan Nama Mobil"
              className="input-field"
            />
            <InputField
              label="Nomor Polisi Mobil"
              disable={driverId && !isEdit}
              value={data.vehicle_number_plate}
              onChange={(e) => setData((prev) => ({ ...prev, vehicle_number_plate: e.target.value }))}
              placeholder="Masukan Nomor Polisi Mobil"
              className="input-field"
            />
            <SelectField
              label="Kategori Mobil"
              type="text"
              disable={driverId && !isEdit}
              data={dataCategory?.category}
              name="vehicle_package"
              value={data.vehicle_category_id}
              htmlFor="vehicle_package"
              placeholder="Pilih Kategori Mobil"
              onChange={(e) => {
                const value = Number.parseInt(e.target.value);
                setData((prev) => ({ ...prev, vehicle_category_id: Number.isNaN(value) ? '' : value }));
              }}
            />
            {driverId && <InputField label="Driver ID" disable value={driverData?.id} className="input-field" />}

            {data?.vehicle_category_id && (
              <div className="baggage-and-passenger">
                <InputField
                  type="number"
                  label="Kapasitas Koper"
                  placeholder={'0'}
                  icon={<LuggageIcon />}
                  iconPosition="start"
                  onWheel={numberInputOnWheelPreventChange}
                  value={data.vehicle_max_suitcases || ''}
                  onChange={(e) => {
                    const value = Number.parseInt(e.target.value);
                    setData((prev) => ({ ...prev, vehicle_max_suitcases: Number.isNaN(value) ? 0 : value }));
                  }}
                  disable={driverId && !isEdit}
                />
                <InputField
                  type="number"
                  label="Kapasitas Penumpang"
                  placeholder={'0'}
                  icon={<AdultsIcon />}
                  iconPosition="start"
                  onWheel={numberInputOnWheelPreventChange}
                  value={data.vehicle_max_passanger || ''}
                  onChange={(e) => {
                    const value = Number.parseInt(e.target.value);
                    setData((prev) => ({ ...prev, vehicle_max_passanger: Number.isNaN(value) ? 0 : value }));
                  }}
                  disable={driverId && !isEdit}
                />
              </div>
            )}

            {data?.vehicle_category_id && (
              <div className="vehicle-foto">
                <h4>Foto Mobil</h4>
                <UploadVehicleImage
                  imageFiles={data?.vehicle_photo}
                  handleRemove={handleRemoveImageVehicle}
                  disable={driverId && !isEdit}
                  uploadAction={handleUploadImageVehicle}
                />
              </div>
            )}
          </div>
        </div>
      </TableWrapper>

      {renderDriverTabs()}

      {driverButtonView()}
    </div>
  );
};

export default AddNewDriver;
